import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import { LoaderService } from '../services/loader/loader.service';
import { MESSAGE_EXPIRE_SESSION, show_popup } from '../utility/popup-error';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class HandleErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private loader: LoaderService,
    private matDialog: MatDialog
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          this.matDialog.closeAll();
          show_popup('', MESSAGE_EXPIRE_SESSION);
          return throwError(error);
        }
        if (this.router.routerState.snapshot.url.startsWith('/login/')) {
          this.router.navigate([this.router.routerState.snapshot.url]);
        }
        return throwError(error);
      })
    );
  }
}
